/* eslint-disable jsx-a11y/control-has-associated-label */
import PassivePagination from 'components/Pagination';
import SearchableHeader from 'components/SearchableHeader';
import SortableHeader from 'components/SortableHeader';
import { saveFile } from 'helpers/utils';
import useSortedSearch from 'hooks/useSortedSearch';
import * as UploadModels from 'models/upload';
import UploadResource from 'models/upload/resource';
import UploadSearcher from 'models/upload/searcher';
import React, { useMemo, useState } from 'react';
import { Form, Table } from 'react-bootstrap';
import * as Contexts from './Context';
import Delete from './Delete';
import UploadRow from './Row';

type Props = {
    values: UploadResource[]
};

export const UploadsTable = ({ values }: Props) => {
  const [selection, setSelection] = useState<Contexts.SelectionValue>({});
  const searcher = useMemo(() => new UploadSearcher(), []);
  const [sorted, sort, search, setSort, setSearch] = useSortedSearch(values, searcher, searcher, {
    type: 'uploadDate',
    asc: false,
  });

  const [filePassword, setFilePassword] = useState('');

  const downloadFile = async (id: number) => {
    try {
      const result = await UploadModels.api.Download(id, filePassword);
      console.log(result);
      saveFile(result.fileName, result.data);
    } catch (error) {
      console.error(error);
      // eslint-disable-next-line no-alert
      alert('Fejl ved henting af fil');
    }
  };

  const selectionValue: Contexts.SelectionContextValue = useMemo(() => ({
    selection,
    setSelection,
  }), [selection, setSelection]);

  return (
    <div className="uploads">
      <Contexts.SelectionContext.Provider value={selectionValue}>
        <Delete />
        <Form.Control type="password" placeholder="Fil password" autoComplete="off" value={filePassword} onChange={(event) => setFilePassword(event.target.value)} />
        <Table>
          <thead>
            <tr>
              <SearchableHeader value={search} types={['fileName']} onSearch={setSearch} />
              <th colSpan={3} />
            </tr>
            <tr>
              <SortableHeader value={sort} type="fileName" onChange={setSort}>
                Fil navn
              </SortableHeader>
              <SortableHeader value={sort} type="uploadDate" onChange={setSort}>
                Upload dato
              </SortableHeader>
            </tr>
          </thead>
          <tbody>
            <PassivePagination
              items={sorted}
              renderItem={(item) => (
                // eslint-disable-next-line max-len
                <UploadRow key={item.id} value={item} onDownloadClick={() => downloadFile(item.id)} />
              )}
            />
          </tbody>
        </Table>
      </Contexts.SelectionContext.Provider>
    </div>
  );
};

export default UploadsTable;
